module.exports = __webpack_public_path__ + "static/media/mongo.ecc6f9e5.png";